import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton", "panel", "toggle"]

  connect() {
    if (this.hasInputTarget && this.inputTarget.value) {
      this.open()
    } else {
      this.closePanel()
    }
    this.toggleClearButton()
  }

  open() {
    if (this.hasPanelTarget) this.panelTarget.classList.remove("hidden")
    if (this.hasToggleTarget) this.toggleTarget.classList.add("hidden")
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  closeIfEmpty() {
    if (this.hasInputTarget && this.inputTarget.value.trim()) return
    this.closePanel()
  }

  toggleClearButton() {
    if (!this.hasClearButtonTarget || !this.hasInputTarget) return

    const show = Boolean(this.inputTarget.value)
    this.clearButtonTarget.classList.toggle("hidden", !show)
    this.clearButtonTarget.classList.toggle("flex", show)
  }

  clearSearch() {
    this.inputTarget.value = ""
    this.toggleClearButton()
    this.panelTarget.requestSubmit()
  }

  closePanel() {
    if (this.hasPanelTarget) this.panelTarget.classList.add("hidden")
    if (this.hasToggleTarget) this.toggleTarget.classList.remove("hidden")
  }
}
